import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, RadioGroup, Radio, FormControlLabel, Checkbox, Select, MenuItem, FormControl, InputLabel, FormLabel as p,  createTheme, ThemeProvider } from '@mui/material';
import { red } from '@mui/material/colors';
import { DrugExceptionsClient } from '../../../client/drug-exceptions-client';
import './exception.css';
import {
    DocumentType,
    DrugExceptionRequest,
    DrugExceptionResponse,
    RelationshipType,
    Gender
} from '../../../model/Reformulary';
import GetLangConfig from '../../../util/LangUtil';
interface HandleError {
    handleError: Function;
}



export default function Exception(props: HandleError) {
    const userId = sessionStorage.getItem('userId') || '';
    const claimantId = JSON.parse(userId);
    const langConfig = GetLangConfig('exception');
    const history = useNavigate();
    const userIdentityObject = sessionStorage.getItem('userIdentityObject') || '';
    const ajaxId = JSON.parse(userIdentityObject);
    const isMember = ajaxId.relationshipType === RelationshipType[RelationshipType.MEMBER];
    const drugExceptionsClient = new DrugExceptionsClient();

    const [stepOneVisible, updateStepOneVisible] = useState(true);
    const [stepTwoVisible, updateStepTwoVisible] = useState(false);
    const [stepThreeVisible, updateStepThreeVisible] = useState(false);


    const [firstName, updateFirstName] = useState('');
    const [lastName, updateLastName] = useState('');
    const [gender, updateGender] = useState('');

    let genderFormatted = langConfig.settings.other;

    if(gender == 'MALE')
        genderFormatted = langConfig.exception.male;
    else if(gender == 'FEMALE')
        genderFormatted = langConfig.exception.female;


    const [dateOfBirthMonth, updateDateOfBirthMonth] = useState('');
    const [dateOfBirthDay, updateDateOfBirthDay] = useState('');
    const [dateOfBirthYear, updateDateOfBirthYear] = useState('');
    const [consented, updateConsented] = useState(false);

    const [images, updateImages] = useState();
    const [pdf, updatePdf] = useState();
    const [docType, updateDoctype] = useState();
    const [newException, updateNewException] = useState();

    const [submitting, updateSubmitting] = useState(false);

    const root = useRef<HTMLDivElement>(null);

    enum SubmittingFor {
        SELF,
        OTHER,
        DEPENDANT
    }

    const [submittingFor, updateSubmittingFor] = useState(SubmittingFor[SubmittingFor.SELF]);

    const theme = createTheme({
        palette: {
            primary: {
                main: '#ff4e00'
            },
            error: red
        },
    });

    function addImages(src: string){
        let newImages;
        if (images !== undefined) {
            newImages = [...images];
        };
        updateImages([...newImages || [], src]);
    }

    async function addToException(data: any) {
            const inputSources = Array.from(document.querySelectorAll('.exception  input'));
            const formData = new FormData();

            inputSources.forEach((source: any, index: number) =>{
                if (source.files[0] !== undefined) {
                    formData.append('image'+index, source.files[0]);
                };

            });

            if (data && claimantId) {
                try {

                    const token = claimantId.authToken;
                    const response = await drugExceptionsClient.api.post(
                        `/drugexceptions/${data.id}/uploaddocuments`,

                        formData
                        ,
                        {
                            headers:{
                                Authorization: `Bearer ${token}`
                            }
                        }
                    );
                    if (response) {

                        history('/dashboard');
                        props.handleError({
                            error: false,
                            ajax: {
                                request: {
                                    responseText: ['Exception created successfully']
                                }
                            }
                        });
                    }
                } catch (error) {
                    props.handleError({
                        error: true,
                        ajax: error
                    });
                }
            }

    }

    async function createDrugException() {
        updateSubmitting(true);
        let id = ajaxId.id;
        const token = claimantId.authToken;

        if(submittingFor !== SubmittingFor[SubmittingFor.SELF]) {
            try {
                const response = await drugExceptionsClient.api.post(
                    '/claimants/dependent',
                    {
                        firstName,
                        lastName,
                        dateOfBirth: new Date(Number(dateOfBirthYear), Number(dateOfBirthMonth), Number(dateOfBirthDay)),
                        gender,
                        relationshipType: submittingFor === SubmittingFor[SubmittingFor.DEPENDANT] ? 'DEPENDANT' : (isMember ? 'SPOUSE' : 'MEMBER')
                    },
                    {
                        headers:{
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                id = response.data.id;
            } catch(error) {
                props.handleError({
                    error: true,
                    ajax: error
                });
            }
        }

        let addedBlob;
        try {
            const response = await drugExceptionsClient.api.post(
                '/drugexceptions',
                {
                    claimantId: id,
                    documentType: docType
                },
                {
                    headers:{
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (response) {
                addedBlob = addToException(response.data);
            }
        } catch(error) {
            props.handleError(error);
        }

    }

    useEffect(()=>{
        if (root.current) {
            const inputSources = Array.from(root.current.querySelectorAll('.exception input'));
            const previewSpots = Array.from(root.current.querySelectorAll<HTMLImageElement>('.exception .image-preview'));
            const previewName = Array.from(root.current.querySelectorAll<HTMLElement>('.exception p'));
            previewSpots.forEach((spot, index) => {
                const fileReader = new FileReader();
                const inputSource: any = inputSources[index];
                const file = inputSource !== undefined ? inputSource.files[0] : false;
                const element = previewName[index];
                element['innerText'] =  inputSource.files[0] ? inputSource.files[0].name : '';

                if (file) {
                    fileReader.addEventListener('load', ()=>{
                        if (typeof fileReader.result === 'string') {
                            spot.setAttribute('src', fileReader.result || '');
                        }
                    });
                    fileReader.readAsDataURL(file);
                }

            });
        }
    });

    function stepTwoAvailable() {
        return true;
    }

    function stepThreeAvailable() {
        return firstName !== ''
            && lastName !== ''
            && gender !== ''
            && dateOfBirthYear !== ''
            && Number(dateOfBirthYear) >= 1900 && Number(dateOfBirthYear) <= 3000
            && dateOfBirthDay !== ''
            && Number(dateOfBirthDay) >= 1 && Number(dateOfBirthDay) <= 31
            && dateOfBirthMonth !== ''
            && consented !== false;
    }

    const handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateFirstName((event.target as HTMLInputElement).value);
    };

    const handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateLastName((event.target as HTMLInputElement).value);
    };

    const handleGenderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateGender((event.target as HTMLInputElement).value);
    };

    const handleSubmittingForChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateSubmittingFor((event.target as HTMLInputElement).value);
    };

    const handleMonthChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        updateDateOfBirthMonth(event.target.value as string);
    };

    const handleDayChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        updateDateOfBirthDay(event.target.value as string);
    };

    const handleYearChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        updateDateOfBirthYear(event.target.value as string);
    };

    const handleConsentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateConsented((event.target as HTMLInputElement).checked);
    };

    function imagesView() {

        return <div className="add-images-container">
            <h1>{langConfig.exception.label1}</h1>

            <div className="exception">
                <div> 
                    <label htmlFor="page-one" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">{langConfig.exception.pageone}</label>
                    <input id="page-one" type="file" accept=".jpg, .jpeg, .JPG, .JPEG; capture=camera" onChange={e=>addImages(e.target.value)} />
                </div>
                <p></p>
                <img className="image-preview" />
            </div>
            <div className="exception">
                <div>
                    <label htmlFor="page-two" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">{langConfig.exception.pagetwo}</label>
                    <input id="page-two" type="file" accept=".jpg, .jpeg, .JPG, .JPEG; capture=camera" onChange={e=>addImages(e.target.value)} />
                </div>
                <p></p>
                <img className="image-preview" />
            </div>
            <div className="exception">
                <div>
                    <label htmlFor="page-three" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">{langConfig.exception.pagethree}</label>
                    <input id="page-three" type="file" accept=".jpg, .jpeg, .JPG, .JPEG; capture=camera" onChange={e=>addImages(e.target.value)} />
                </div>
                <p></p>
                <img className="image-preview" />
            </div>
            <div className="exception">
                <div>
                    <label htmlFor="page-four" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">{langConfig.exception.pagefour}</label>
                    <input id="page-four" type="file" accept=".jpg, .jpeg, .JPG, .JPEG; capture=camera" onChange={e=>addImages(e.target.value)} />
                </div>
                <p></p>
                <img className="image-preview" />
            </div>
        </div>;

    }

    function PDFView() {
        return <div className="add-pdf-container">
            <h1>{langConfig.exception.label1}</h1>
            <div className="exception">
                <div>
                    <label htmlFor="pdf" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">{langConfig.exception.label21}</label>
                    <input id="pdf" type="file"  accept="application/pdf" onChange={e=>updatePdf(e.target.value)} />
                </div>
                <p></p>
                <svg version="1.1" id="Capa_1"  x="50px" y="50px" viewBox="50 0 -50 0" className="image-preview">
                    <g>
                        <path d="M142.024,310.194c0-8.007-5.556-12.782-15.359-12.782c-4.003,0-6.714,0.395-8.132,0.773v25.69
                            c1.679,0.378,3.743,0.504,6.588,0.504C135.57,324.379,142.024,319.1,142.024,310.194z"/>
                        <path d="M202.709,297.681c-4.39,0-7.227,0.379-8.905,0.772v56.896c1.679,0.394,4.39,0.394,6.841,0.394
                            c17.809,0.126,29.424-9.677,29.424-30.449C230.195,307.231,219.611,297.681,202.709,297.681z"/>
                        <path d="M315.458,0H121.811c-28.29,0-51.315,23.041-51.315,51.315v189.754h-5.012c-11.418,0-20.678,9.251-20.678,20.679v125.404
                            c0,11.427,9.259,20.677,20.678,20.677h5.012v22.995c0,28.305,23.025,51.315,51.315,51.315h264.223
                            c28.272,0,51.3-23.011,51.3-51.315V121.449L315.458,0z M99.053,284.379c6.06-1.024,14.578-1.796,26.579-1.796
                            c12.128,0,20.772,2.315,26.58,6.965c5.548,4.382,9.292,11.615,9.292,20.127c0,8.51-2.837,15.745-7.999,20.646
                            c-6.714,6.32-16.643,9.157-28.258,9.157c-2.585,0-4.902-0.128-6.714-0.379v31.096H99.053V284.379z M386.034,450.713H121.811
                            c-10.954,0-19.874-8.92-19.874-19.889v-22.995h246.31c11.42,0,20.679-9.25,20.679-20.677V261.748
                            c0-11.428-9.259-20.679-20.679-20.679h-246.31V51.315c0-10.938,8.921-19.858,19.874-19.858l181.89-0.19v67.233
                            c0,19.638,15.934,35.587,35.587,35.587l65.862-0.189l0.741,296.925C405.891,441.793,396.987,450.713,386.034,450.713z
                             M174.065,369.801v-85.422c7.225-1.15,16.642-1.796,26.58-1.796c16.516,0,27.226,2.963,35.618,9.282
                            c9.031,6.714,14.704,17.416,14.704,32.781c0,16.643-6.06,28.133-14.453,35.224c-9.157,7.612-23.096,11.222-40.125,11.222
                            C186.191,371.092,178.966,370.446,174.065,369.801z M314.892,319.226v15.996h-31.23v34.973h-19.74v-86.966h53.16v16.122h-33.42
                            v19.875H314.892z"/>
                    </g>

                    </svg>
            </div>
        </div>;
    }

    function addZ(n: number){return n<10? '0'+n:''+n;}

    function chooseView() {
        return <div className="choose-view">
            <div>
                <h1>{langConfig.exception.label1}</h1>
                <p>
                    {langConfig.exception.exceptionp1}
                </p>
                <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>updateDoctype(DocumentType[DocumentType.JPG])}>
                    <div className="mdc-button__ripple"></div>
                    <span className="mdc-button__label">Image (Photos)</span>
                </button>
                <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>updateDoctype(DocumentType[DocumentType.PDF])}>
                    <div className="mdc-button__ripple"></div>
                    <span className="mdc-button__label">PDF</span>
                </button>
            </div>
            <div className="claimant-details">
                <h3>{langConfig.exception.label5}</h3>
                <p>{langConfig.exception.label6}:</p>
                <p>{firstName} {lastName}</p>
                <p>{langConfig.exception.label7}:</p>
                <p>{`${addZ(Number(dateOfBirthDay))}/${addZ(Number(dateOfBirthMonth)+1)}/${dateOfBirthYear}`}</p>
                <p>{langConfig.exception.label8}:</p>
                <p>{genderFormatted.charAt(0) + genderFormatted.slice(1).toLowerCase()}</p>
            </div>
        </div>;
    }

    return (
        <div className="new-exception-container" ref={root}>
            <ThemeProvider theme={theme}>
                <div className={'step-one '+(stepOneVisible ? '' : 'hidden')}>
                <h1>{langConfig.exception.label1}</h1>
                    <div>
                        <p>{langConfig.exception.label2}</p>
                        <RadioGroup name="submittingFor" value={submittingFor} onChange={handleSubmittingForChange}>
                            <FormControlLabel value={SubmittingFor[SubmittingFor.SELF]} control={<Radio />} label={langConfig.exception.label3 + (isMember ? langConfig.exception.planmember : langConfig.exception.spouse)} />
                            <FormControlLabel value={SubmittingFor[SubmittingFor.OTHER]} control={<Radio />} label={isMember ? langConfig.exception.spouse : langConfig.exception.planmember} />
                            <FormControlLabel value={SubmittingFor[SubmittingFor.DEPENDANT]} control={<Radio />} label={langConfig.exception.dependentchild} />
                        </RadioGroup>
                    </div>
                    <div>
                        {
                            !stepTwoAvailable
                            ? <button className="inactive mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped ">
                                    <div className="mdc-button__ripple"></div>
                                    <span className="mdc-button__label">{langConfig.exception.label4}</span>
                            </button>
                            : <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>{ 
                                if(submittingFor === SubmittingFor[SubmittingFor.SELF]) {
                                    updateFirstName(ajaxId.firstName);
                                    updateLastName(ajaxId.lastName);
                                    updateGender(ajaxId.gender);
                                    updateDateOfBirthDay(new Date(ajaxId.dateOfBirth).getUTCDate().toString());
                                    updateDateOfBirthMonth(new Date(ajaxId.dateOfBirth).getUTCMonth().toString());
                                    updateDateOfBirthYear(new Date(ajaxId.dateOfBirth).getUTCFullYear().toString());
                                    updateStepOneVisible(false);
                                    updateStepTwoVisible(false);
                                    updateStepThreeVisible(true);
                                } else {
                                    updateStepOneVisible(false);
                                    updateStepTwoVisible(true);
                                    updateStepThreeVisible(false);
                                }
                            }}>
                                <div className="mdc-button__ripple"></div>
                                <span className="mdc-button__label">{langConfig.exception.label4}</span>
                            </button>

                        }
                    </div>
                </div>
                <div className={'step-two '+(stepTwoVisible ? '' : 'hidden')}>
                    <div className="claimant-details">
                        <h1>{langConfig.exception.label1}</h1>
                        <p style={ { fontWeight: 'bold' } }>{submittingFor === SubmittingFor[SubmittingFor.DEPENDANT] ? langConfig.exception.label11 : (isMember ? langConfig.exception.label9 : langConfig.exception.label10)}</p>
                        <p>{langConfig.exception.label15} {submittingFor === SubmittingFor[SubmittingFor.DEPENDANT] ? langConfig.exception.label12 : (isMember ? langConfig.exception.label12 : langConfig.exception.label13)}</p>
                        <div className="name">
                            <TextField
                                id="firstname-input"
                                label={langConfig.general.firstname}
                                defaultValue={firstName}
                                onChange={handleFirstNameChange}
                                variant="filled" 
                                margin="normal"
                            />
                            <TextField
                                id="lastname-input"
                                label={langConfig.general.lastname}
                                defaultValue={lastName}
                                onChange={handleLastNameChange}
                                variant="filled"
                                margin="normal"
                            />

                        </div>
                        <p>{langConfig.exception.label7}</p>
                        <div className="date-of-birth">
                            <TextField
                                id="year-input"
                                label={langConfig.general.year}
                                value={dateOfBirthYear}
                                onChange={handleYearChange}
                                error={dateOfBirthYear !== '' && (Number(dateOfBirthYear) < 1900 || Number(dateOfBirthYear) > 3000)}
                                variant="filled"
                                margin="normal"
                                type="number"
                            />
                            <FormControl variant="filled" margin="normal">
                                <InputLabel id="month-input-label">{langConfig.general.month}</InputLabel>
                                <Select
                                    labelId="month-input-label"
                                    id="month-input"
                                    value={dateOfBirthMonth}
                                    onChange={handleMonthChange}
                                >
                                    <MenuItem value={0}>{langConfig.general.january}</MenuItem>
                                    <MenuItem value={1}>{langConfig.general.february}</MenuItem>
                                    <MenuItem value={2}>{langConfig.general.march}</MenuItem>
                                    <MenuItem value={3}>{langConfig.general.april}</MenuItem>
                                    <MenuItem value={4}>{langConfig.general.may}</MenuItem>
                                    <MenuItem value={5}>{langConfig.general.june}</MenuItem>
                                    <MenuItem value={6}>{langConfig.general.july}</MenuItem>
                                    <MenuItem value={7}>{langConfig.general.august}</MenuItem>
                                    <MenuItem value={8}>{langConfig.general.september}</MenuItem>
                                    <MenuItem value={9}>{langConfig.general.october}</MenuItem>
                                    <MenuItem value={10}>{langConfig.general.november}</MenuItem>
                                    <MenuItem value={11}>{langConfig.general.december}</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                id="day-input"
                                label={langConfig.general.day}
                                value={dateOfBirthDay}
                                onChange={handleDayChange}
                                error={dateOfBirthDay !== '' && (Number(dateOfBirthDay) < 1 || Number(dateOfBirthDay) > 31)}
                                variant="filled"
                                margin="normal"
                                type="number"
                            />
                        </div>
                        <div>
                            <p>Gender</p>
                            <RadioGroup aria-required aria-label="gender" name="gender" value={gender} onChange={handleGenderChange} row>
                                <FormControlLabel value={Gender[Gender.MALE]} control={<Radio />} label={langConfig.exception.male} />
                                <FormControlLabel value={Gender[Gender.FEMALE]} control={<Radio />} label={langConfig.exception.female} />
                                <FormControlLabel value={Gender[Gender.OTHER]} control={<Radio />} label={langConfig.exception.other} />
                            </RadioGroup>
                        </div>
                    </div>
                    <div className="consent">
                        <FormControlLabel
                            control={<Checkbox checked={consented} onChange={handleConsentChange} />}
                            label={submittingFor === SubmittingFor[SubmittingFor.DEPENDANT] ? langConfig.exception.label19 : (isMember ? langConfig.exception.label17 : langConfig.exception.label18)}
                        />
                    </div>
                    <div>
                        <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>{
                            updateStepOneVisible(true);
                            updateStepTwoVisible(false);
                            updateStepThreeVisible(false);
                        }}>
                            <div className="mdc-button__ripple"></div>
                            <span className="mdc-button__label">{langConfig.exception.label16}</span>
                        </button>
                    </div>
                    <div>
                        {
                            !stepThreeAvailable()
                            ? <button className="inactive mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped ">
                                    <div className="mdc-button__ripple"></div>
                                    <span className="mdc-button__label">{langConfig.exception.label4}</span>
                            </button>
                            : <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>{ 
                                updateStepOneVisible(false);
                                updateStepTwoVisible(false);
                                updateStepThreeVisible(true);
                            }}>
                                <div className="mdc-button__ripple"></div>
                                <span className="mdc-button__label">{langConfig.exception.label4}</span>
                            </button>

                        }
                    </div>
                </div>

                <div className={'step-three '+(stepThreeVisible ? '' : 'hidden')}>

                    {
                        docType === undefined
                        ? chooseView()
                        : docType === DocumentType[DocumentType.JPG]
                            ? imagesView()
                            : PDFView()
                    }

                    {
                        docType === undefined
                            ? ''
                            : images !== undefined || pdf !== undefined
                                ? <button disabled={submitting} className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={createDrugException}>
                                    <div className="mdc-button__ripple"></div>
                                    <span className="mdc-button__label">{langConfig.exception.label20}</span>
                                </button>
                                : <button disabled className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" >
                                    <div className="mdc-button__ripple"></div>
                                    <span className="mdc-button__label">{langConfig.exception.label20}</span>
                                </button>
                    }
                </div>
            </ThemeProvider>
        </div>
    );

}
